import React from "react";
import styled from "styled-components";
import {Route, Redirect, Switch} from "react-router";

const Login = React.lazy(() => import(/* webpackChunkName: "login" */ "../Login/Login"));

const Register1 = React.lazy(() =>
    import(/* webpackChunkName: "registerPage1" */ "../Register/Register1/Register1"),
);

const Register2 = React.lazy(() =>
    import(/* webpackChunkName: "registerPage2" */ "../Register/Register2/Register2"),
);

const AccountLocked = React.lazy(() =>
    import(/* webpackChunkName: "accountLocked" */ "../AccountLocked/AccountLocked"),
);

const PasswordReset = React.lazy(() =>
    import(/* webpackChunkName: "passwordReset" */ "../PasswordReset/PasswordReset"),
);

const PasswordResetRequested = React.lazy(() =>
    import(/* webpackChunkName: "passwordResetRequested" */ "../PasswordReset/PasswordResetRequested"),
);

const AuthContainer = styled.div`
    height: calc(100% - 80px);
    background-color: var(--theme-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;

    @media (min-width: 768px) {
        display: flex;
    }
`;

const AuthRoutes = ({match, isOpenDay}) => {
    const baseUrl = match.path.endsWith("/") ? match.path.slice(0, -1) : match.path;
    const originUrl = match.url.replace(/\bauth\b/g, '');

    return (
        <AuthContainer>
            <Switch>
                <Route
                    path={`${baseUrl}/login`}
                    render={props => (
                        <Login redirectUrl={originUrl} isOpenDay={isOpenDay} {...props} />
                    )}
                />
                <Route
                    path={`${baseUrl}/register2`}
                    render={props => (
                        <Register2 redirectUrl={originUrl} isOpenDay={isOpenDay} {...props} />
                    )}
                />
                <Route
                    path={`${baseUrl}/register`}
                    render={props => (
                        <Register1
                            loginUrl={`${originUrl}/auth/login`}
                            isOpenDay={isOpenDay}
                            {...props}
                        />
                    )}
                />
                <Route path={`${baseUrl}/reset`} render={props => <PasswordReset {...props} />} />
                <Route
                    path={`${baseUrl}/resetrequested`}
                    render={props => <PasswordResetRequested {...props} />}
                />
                <Route path={`${baseUrl}/accountlocked`} render={() => <AccountLocked />} />
                <Redirect from={`${baseUrl}`} to={`${baseUrl}/login`} />
            </Switch>
        </AuthContainer>
    );
};

AuthRoutes.defaultProps = {
    isOpenDay: false,
};

export default AuthRoutes;
